import { BuyerSeatDetailDto, BuyerSeatDto, BuyerSeatListPageDto, BuyerSeatUpdateDto } from './dto/buyer-seat-dto';
import { BuyerSeatRequestDto } from './dto/buyer-seat-request-dto';
import applicationApi from '../api';
import { BuyerSeatPageDto } from './dto/user-managment-dto/organization-detail-dto';


const createBuyerSeat = async (body: BuyerSeatRequestDto): Promise<BuyerSeatDto> => {
  const response = await applicationApi.post('/buyer-seat', body);
  return response.data;
};

const getBuyerSeats = async (): Promise<BuyerSeatDto[]> => {
  const response = await applicationApi.get('/buyer-seat');
  return response.data.map(
    (buyerSeat: BuyerSeatDto): BuyerSeatDto => ({
      ...buyerSeat,
      buyerSeatNameAndId: `${buyerSeat.name} (${buyerSeat.buyerSeatId})`, // populate frontend specific field
    })
  );
};

const getBuyerSeatCount = async (): Promise<number> => {
  const response = await applicationApi.get('/buyer-seat/count');
  return response.data;
}

const getBuyerSeatsByOrganization = async (
  orgId: string,
  params: { search?: string; status?: string; page?: number; size?: number }
): Promise<BuyerSeatPageDto> => {
  const response = await applicationApi.get(`/buyer-seat/organization/${orgId}`, { params });
  return response.data;
};

const getBuyerSeatList = async (params: {
  search?: string;
  status?: string;
  page?: number;
  size?: number;
  sort?: string;
}): Promise<BuyerSeatListPageDto> => {
  const response = await applicationApi.get('/buyer-seat/list', { params });
  return response.data;
};

const getActiveBuyerSeatCount = async (): Promise<number> => {
  const response = await applicationApi.get('/buyer-seat/count/active');
  return response.data;
};

const getBuyerSeatById = async (id: number): Promise<BuyerSeatDetailDto> => {
  const response = await applicationApi.get(`/buyer-seat/${id}`);
  return response.data;
};

const updateBuyerSeat = async (id: number, body: BuyerSeatUpdateDto): Promise<BuyerSeatDetailDto> => {
  const response = await applicationApi.patch(`/buyer-seat/${id}`, body);
  return response.data;
};

export const buyerSeatService = {
  createBuyerSeat,
  getBuyerSeats,
  getBuyerSeatCount,
  getBuyerSeatsByOrganization,
  getBuyerSeatList,
  getActiveBuyerSeatCount,
  getBuyerSeatById,
  updateBuyerSeat
};
